import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07671827"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "row other-titles" }
const _hoisted_4 = {
  key: 2,
  class: "row"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  class: "table table-small",
  "data-testid": "writers-table"
}
const _hoisted_7 = { width: "19%" }
const _hoisted_8 = { width: "18%" }
const _hoisted_9 = { width: "18%" }
const _hoisted_10 = { width: "6%" }
const _hoisted_11 = { width: "6%" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = ["data-header"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["data-header"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["data-header"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["data-header"]
const _hoisted_21 = ["data-header"]
const _hoisted_22 = ["data-header"]
const _hoisted_23 = ["data-header"]
const _hoisted_24 = { class: "writer-actions" }
const _hoisted_25 = {
  key: 3,
  class: "row"
}
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = {
  class: "table table-small",
  "data-testid": "samples-table"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_29 = ["data-testid"]
const _hoisted_30 = ["data-header"]
const _hoisted_31 = ["title"]
const _hoisted_32 = ["data-header"]
const _hoisted_33 = ["title"]
const _hoisted_34 = ["data-header"]
const _hoisted_35 = {
  key: 4,
  class: "row"
}
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = {
  class: "table table-small",
  "data-testid": "society-work-table"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["data-header"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "ISWC", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["data-header"]
const _hoisted_43 = ["title"]
const _hoisted_44 = ["data-header"]
const _hoisted_45 = ["data-header"]
const _hoisted_46 = ["data-testid"]
const _hoisted_47 = ["data-header"]
const _hoisted_48 = ["data-header"]
const _hoisted_49 = ["title"]
const _hoisted_50 = ["data-header"]
const _hoisted_51 = ["data-header"]
const _hoisted_52 = {
  key: 5,
  class: "row justify-end"
}
const _hoisted_53 = ["disabled"]

import dayjs from 'dayjs'
import { computed, ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import {
  getSocietyStatusColor,
  getWriterStatusColor,
  SocietyStatusesText,
  WorkStatuses,
  WriterRolesText,
  WriterStatuses,
} from '@/constants'
import { useWorksStore } from '@/store/works'
import { useUserStore } from '@/store/user'
import { getErrorTitle, getErrorMessage } from '@/helpers/errors'
import IconUI from '@/components/CommonUI/IconUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import WriterActions from '@/components/MyWorks/WriterActions.vue'
import TerminateWorkDialog from './TerminateWorkDialog.vue'

interface WorkItemProps {
  work: Work
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkDetails',
  props: {
    work: {}
  },
  setup(__props: any) {

const props = __props;


const workStore = useWorksStore()
const userStore = useUserStore()
const { $gettext } = useGettext()

const terminateDialog = ref<InstanceType<typeof TerminateWorkDialog> | null>(null)

const errorMessage = ref('')
const errorTitle = ref('')
const isDeleting = ref(false)

const getWriterStatusColorClass = (status: number) => getWriterStatusColor(status)
const getSocietyStatusColorClass = (status: number | null) => getSocietyStatusColor(status)

const deletableWorkStatuses = [WorkStatuses.pending.id, WorkStatuses.rejected.id]
const canDelete = computed(() => deletableWorkStatuses.includes(Number(props.work.status)))

const isTerminated = computed(() => Number(props.work.status) === WorkStatuses.terminated.id)
const canTerminate = computed(() => Number(props.work.status) === WorkStatuses.registered.id)

function setError(title = '', message = '') {
  errorTitle.value = title
  errorMessage.value = message
}

function getStatusText(societyCodeStatus: number | null) {
  return societyCodeStatus === null
    ? 'N/A'
    : $gettext(SocietyStatusesText[societyCodeStatus])
}

async function deleteWork(workId: number) {
  try {
    isDeleting.value = true
    await workStore.deleteWork(workId)
    isDeleting.value = false
  } catch (error) {
    setError(getErrorTitle(error), getErrorMessage(error))
  }
}

function showTerminateDialog() {
  terminateDialog.value?.show()
}


return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "work-details",
      "data-testid": `work-details${_ctx.work.id}`
    }, [
      (errorMessage.value || errorTitle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(NotificationUI, {
              message: errorMessage.value,
              title: errorTitle.value
            }, null, 8, ["message", "title"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.work.alternative_titles?.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _withDirectives((_openBlock(), _createElementBlock("h5", null, [
              _createTextVNode(" Other Titles ")
            ])), [
              [_directive_translate]
            ]),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.work.alternative_titles?.map(({ name }) => name).join(', ')), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.work.writers?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createElementBlock("h5", null, [
                _createTextVNode(" Writer(s) / Composer(s) ")
              ])), [
                [_directive_translate]
              ]),
              _createElementVNode("table", _hoisted_6, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_7, [
                      _createTextVNode(" Legal Name: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_8, [
                      _createTextVNode(" Email: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_9, [
                      _createTextVNode(" Writer Role: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Controlled: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" IPI/CAE Number: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_10, [
                      _createTextVNode(" Share: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_11, [
                      _createTextVNode(" Status: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _hoisted_12
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.writers, (writer) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: writer.id,
                      "data-testid": `writer-item${writer.id}`
                    }, [
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Legal Name:')
                      }, [
                        _createElementVNode("strong", {
                          class: "truncate-line",
                          title: writer.name
                        }, _toDisplayString(writer.name), 9, _hoisted_15)
                      ], 8, _hoisted_14),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Email:')
                      }, [
                        _createElementVNode("span", {
                          class: "truncate-line",
                          title: writer.email
                        }, _toDisplayString(writer.email), 9, _hoisted_17)
                      ], 8, _hoisted_16),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Writer Role:')
                      }, [
                        _createElementVNode("span", {
                          class: "truncate-line",
                          title: _unref($gettext)(_unref(WriterRolesText)[Number(writer.role)])
                        }, _toDisplayString(_unref($gettext)(_unref(WriterRolesText)[Number(writer.role)])), 9, _hoisted_19)
                      ], 8, _hoisted_18),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Controlled:')
                      }, _toDisplayString(writer.isControlled ? _unref($gettext)('Yes') : _unref($gettext)('No')), 9, _hoisted_20),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('IPI/CAE Number:')
                      }, _toDisplayString(writer.ipi_cae_number || 'N/A'), 9, _hoisted_21),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Share:')
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(writer.share) + "%", 1)
                      ], 8, _hoisted_22),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Status:'),
                        class: "status-wrapper"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["status", getWriterStatusColorClass(Number(writer.status))]),
                          "data-testid": "writer-status"
                        }, null, 2)
                      ], 8, _hoisted_23),
                      _createElementVNode("td", _hoisted_24, [
                        (writer.status === _unref(WriterStatuses).requested && writer.user_id !== _unref(userStore).user.id)
                          ? (_openBlock(), _createBlock(WriterActions, {
                              key: 0,
                              "writer-id": Number(writer.id),
                              "work-id": Number(_ctx.work.id),
                              "sent-emails": Number(writer.sent_emails),
                              "writer-created-date": writer.created_at,
                              "is-controlled": writer.isControlled,
                              onHandleError: setError
                            }, null, 8, ["writer-id", "work-id", "sent-emails", "writer-created-date", "is-controlled"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_13))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.work.samples?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _withDirectives((_openBlock(), _createElementBlock("h5", null, [
                _createTextVNode(" Samples ")
              ])), [
                [_directive_translate]
              ]),
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Title of work used: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Writers: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Share: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _hoisted_28
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.samples, (sample) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: sample.id,
                      "data-testid": `sample-item-${sample.id}`
                    }, [
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Title of work used:')
                      }, [
                        _createElementVNode("span", {
                          class: "truncate-line",
                          title: sample.title
                        }, _toDisplayString(sample.title), 9, _hoisted_31)
                      ], 8, _hoisted_30),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Writers:')
                      }, [
                        _createElementVNode("span", {
                          class: "truncate-line",
                          title: sample.writers_names
                        }, _toDisplayString(sample.writers_names), 9, _hoisted_33)
                      ], 8, _hoisted_32),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Share:')
                      }, _toDisplayString(sample.share) + "% ", 9, _hoisted_34)
                    ], 8, _hoisted_29))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.work.societies?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives((_openBlock(), _createElementBlock("h5", null, [
                _createTextVNode(" Society Work Codes ")
              ])), [
                [_directive_translate]
              ]),
              _createElementVNode("table", _hoisted_37, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Society: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Work Code: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Status: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                      _createTextVNode(" Registration Date: ")
                    ])), [
                      [_directive_translate]
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.work.iswc)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                        _createElementVNode("td", {
                          "data-header": _unref($gettext)('Society:')
                        }, _hoisted_41, 8, _hoisted_39),
                        _createElementVNode("td", {
                          "data-header": _unref($gettext)('Work Code:')
                        }, [
                          _createElementVNode("span", {
                            class: "truncate-line",
                            title: _ctx.work.iswc
                          }, _toDisplayString(_ctx.work.iswc), 9, _hoisted_43)
                        ], 8, _hoisted_42),
                        _createElementVNode("td", {
                          "data-header": _unref($gettext)('Status:')
                        }, null, 8, _hoisted_44),
                        _createElementVNode("td", {
                          "data-header": _unref($gettext)('Registration Date:')
                        }, null, 8, _hoisted_45)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.societies, (societyCode, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index + societyCode.code,
                      "data-testid": `society-work-item${societyCode.code}`
                    }, [
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Society:')
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(societyCode.name), 1)
                      ], 8, _hoisted_47),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Work Code:')
                      }, [
                        _createElementVNode("span", {
                          class: "truncate-line",
                          title: societyCode.code
                        }, _toDisplayString(societyCode.code), 9, _hoisted_49)
                      ], 8, _hoisted_48),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Status:')
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["status no-circle", getSocietyStatusColorClass(societyCode.status)])
                        }, _toDisplayString(getStatusText(societyCode.status)), 3)
                      ], 8, _hoisted_50),
                      _createElementVNode("td", {
                        "data-header": _unref($gettext)('Registration Date:')
                      }, _toDisplayString(societyCode.registered_at
                    ? _unref(dayjs)(societyCode.registered_at).format('DD MMMM YYYY')
                    : 'N/A'), 9, _hoisted_51)
                    ], 8, _hoisted_46))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!isTerminated.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            (canDelete.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button tertiary button-small delete-work-button",
                  type: "button",
                  disabled: isDeleting.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteWork(Number(_ctx.work.id))))
                }, [
                  _createVNode(IconUI, { name: "rubbish-bin" }),
                  _createTextVNode(" " + _toDisplayString(isDeleting.value ? _unref($gettext)('Deleting work...') : _unref($gettext)('Delete work')), 1)
                ], 8, _hoisted_53))
              : _createCommentVNode("", true),
            (canTerminate.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button tertiary button-small delete-work-button",
                  "data-testid": "terminate-button",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showTerminateDialog()))
                }, _toDisplayString(_unref($gettext)('Terminate')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createVNode(TerminateWorkDialog, {
      ref_key: "terminateDialog",
      ref: terminateDialog,
      "data-testid": "terminate-dialog",
      "work-id": Number(_ctx.work.id)
    }, null, 8, ["work-id"])
  ]))
}
}

})